import axios from 'axios'
import axiosRetry from 'axios-retry'
import StorageUtil from '@/utils/storageUtil'
import { getAcDomainByCustomerNumber } from '@/utils/helper'

const axiosReq = axios.create({
  timeout: 1000 * 30
})

axiosRetry(axiosReq, {
  retries: 2,
  retryDelay: (retryCount) => {
    return retryCount * 1000 // Time in milliseconds: waits 1s, then 2s, then 3s
  }
})

export default {
  header() {
    const headers = {
      Authorization: StorageUtil.readToken(),
      deviceType: "mb",
      pageType: StorageUtil.readPageType(),
      lang: JSON.parse(process.env.VUE_APP_LANG).zn,
    };
    return headers;
  },
  header1() {
    const headers = {
      deviceType: "mb",
      pageType: StorageUtil.readPageType(),
      lang: JSON.parse(process.env.VUE_APP_LANG).zn,
    };
    return headers;
  },
  header2() {
    const headers = {
      isAjax: true,
      // lang: JSON.parse(process.env.VUE_APP_LANG).zn
    };
    return headers;
  },
  header3() {
    const headers = {};
    return headers;
  },
  headersForAcNoAuth() {
    return {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  },
  headersForAc() {
    return {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: StorageUtil.readToken()
    }
  },
  headersForMis() {
    return {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: StorageUtil.readToken()
    }
  },
  headersForMisJson() {
    return {
      'Content-Type': 'text/plain',
      Authorization: StorageUtil.readToken()
    }
  },
  i18n(headers) {
    headers.lang = i18n.locale;
    return headers;
  },
  queryParams(params) {
    // Initialize URLSearchParams with the provided params object.
    // This gracefully handles cases where params is null or undefined.
    const searchParams = new URLSearchParams(params);

    // Check if the 'platform' parameter does NOT already exist.
    if (!searchParams.has('platform')) {
      // If it's missing, add it with the value from StorageUtil.
      searchParams.set('platform', StorageUtil.readPlatform());
    }

    // Convert the searchParams object back to a string.
    const queryString = searchParams.toString();

    // Return the string prepended with '?' only if it's not empty.
    return queryString ? `?${queryString}` : '';
  },
  getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  },
  requestBody(body) {
    let result = {
      platform: StorageUtil.readPlatform(),
    };
    for (const [key, value] of Object.entries(body)) {
      result[key] = value;
    }
    return this.getFormData(result);
  },
  /* 极验*/
  gt() {
    return axiosReq.get(process.env.VUE_APP_API_URL + `/gt/register`, {
      headers: { lang: JSON.parse(process.env.VUE_APP_LANG).zn },
    });
  },
  /* 验证码*/
  send(data, head) {
    return axiosReq.post(process.env.VUE_APP_API_URL + `/sms/send`, data, {
      headers: head,
    });
  },
  /* 交易登录*/
  tradeLogin(data) {
    return axiosReq.post(process.env.VUE_APP_API_TRADE + `/webui/login`, data, {
      headers: this.header1(),
    });
  },
  /* 根据token获取用户信息*/
  getCacheCustomerByToken(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/account/getCacheCustomerByToken`,
      { headers: { Authorization: data } }
    );
  },
  /* 登录*/
  login(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/account/realDemoLogin`,
      data,
      { headers: this.header1() }
    );
  },
  /* 根据账号或手机号查询账户信息*/
  getCustomerInfoByAccountNo(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/account/getCustomerInfoByAccountNo?accountNo=` +
        data,
      { headers: this.header1() }
    );
  },
  /* 忘记密码*/
  forgetPwd(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/account/setPassword`,
      data,
      { headers: this.header1() }
    );
  },
  /**
   * should be stringify
   * @param {Object} data
   * @param {string} data.key
   * @param {string} data.password
   */
  setPasswordByEmail(data) {
    return axios.post(
      process.env.VUE_APP_API_URL + "/forgetPwd/setPassWordByEmail",
      data,
      { headers: this.header1() }
    );
  },

  /* 修改密码*/
  modifyPassword(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/account/modifyPassword`,
      data,
      { headers: this.header() }
    );
  },
  /* 轮播*/
  queryForApp() {
    return axiosReq.get(process.env.VUE_APP_CMS + `/api/ad/actions/25`, {
      headers: this.header2(),
    });
  },
  /* 用户交易账号信息*/
  getAccTradeInfo(data) {
    const params = {
      gts2CustomerId: data,
    };
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/person/getAccTradeInfo${this.queryParams(
        params
      )}`,
      { headers: this.header() }
    );
  },
  addMT5() {
    return axiosReq.get(`${process.env.VUE_APP_API_URL}/person/addMT5`, {
      headers: this.header(),
    });
  },
  /* 个人信息是否完善*/
  getCertifyInfo() {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/person/getCertifyInfo`,
      {
        headers: this.header(),
      }
    );
  },
  /* 获取个人中心证明信息*/
  getAuthInfo() {
    return axiosReq.get(process.env.VUE_APP_API_URL + `/person/getAuthInfo`, {
      headers: this.header(),
    });
  },
  /* 获取验证标记权限*/
  getLabelAuthority() {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/risk/getLabelAuthority`,
      {
        headers: this.header(),
      }
    );
  },
  /* 是否需要人脸*/
  getFaceStatus(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/risk/getFaceStatus?` + data,
      { headers: this.header() }
    );
  },
  /* 校验存款所需要的证明状态*/
  getDepositAuthCertify() {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/risk/getDepositAuthCertify${this.queryParams()}`,
      { headers: this.header() }
    );
  },
  /* 检查取款银行卡账号是否重复*/
  checkDuBankAccNumber(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/bank/checkDuBankAccNumber`,
      data,
      { headers: this.header() }
    );
  },
  /* 根据银行卡查询相应的银行名称*/
  getBankByCardNumber(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/bank/getBankByCardNumber?cardNumber=` +
        data,
      { headers: this.header() }
    );
  },
  /* 获取数据字典接口*/
  getDictInfo(data) {
    const params = {
      dictCode: data,
    };
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/dict/getDictInfo${this.queryParams(
        params
      )}`,
      { headers: this.header() }
    );
  },
  /* 获取产品接口*/
  getSymbolList() {
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/tradereport/getSymbolList${this.queryParams()}`,
      { headers: this.header() }
    );
  },
  /* 获取国家列表*/
  getCountry() {
    return axiosReq.get(process.env.VUE_APP_API_URL + `/dict/getCountry`, {
      headers: this.header(),
    });
  },
  /* 获取省份列表*/
  getProvincesByCountry(code) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/dict/getProvincesByCountry?country=` +
        code,
      { headers: this.header() }
    );
  },
  /* 获取城市列表*/
  getCitiesByProvince(nameEng) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/dict/getCitiesByProvince?province=` +
        nameEng,
      { headers: this.header() }
    );
  },
  /* 银行卡三元素验证*/
  verifyBankElement(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/risk/verifyBankElement`,
      data,
      { headers: this.header() }
    );
  },
  /* 添加存款银行卡*/
  addDepositBank(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/bank/addDepositBank`,
      data,
      { headers: this.header() }
    );
  },
  /* 添加取款银行卡*/
  addWithdrawBank(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/bank/addWithdrawBank`,
      data,
      { headers: this.header() }
    );
  },
  /* 上传取款银行证明文件*/
  uploadCertificate(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/upload/uploadCertificate`,
      data,
      { headers: this.header() }
    );
  },
  /* 存款银行列表*/
  getDepositBankList() {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/bank/getDepositBankList`,
      {
        headers: this.header(),
      }
    );
  },
  /* 删除存款银行卡*/
  deleteDepositBank(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/bank/deleteDepositBank`,
      data,
      { headers: this.header() }
    );
  },
  deleteWithdrawBank(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/bank/deleteWithdrawBank`,
      data,
      { headers: this.header() }
    );
  },
  /* 保存支付设置*/
  updatePaySwitch(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/fund/updatePaySwitch`,
      data,
      { headers: this.header() }
    );
  },
  /* 提现银行列表*/
  getWithdrawBankList() {
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/bank/getWithdrawBankList${this.queryParams()}`,
      { headers: this.header() }
    );
  },
  /* 添加支行名称 */
  updateBankBranch(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + "/bank/updateBranch",
      this.requestBody(data),
      {
        headers: this.header(),
      }
    );
  },
  /* 获取mis存款金额列表*/
  getAmountSetting() {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/fund/getAmountSetting${this.queryParams()}`,
      { headers: this.header() }
    );
  },
  /* 获取可用的支付方式列表*/
  getPaySwitchSeqList(data) {
    const params = {
      gts2CustomerId: data,
    };
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/fund/getPaySwitchSeqList${this.queryParams(params)}`,
      { headers: this.header() }
    );
  },
  /* 获取快捷支付银行列表*/
  getBankListByPayId(data) {
    const params = {
      paySwitchSeqId: data,
    };
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/fund/getBankListByPayId${this.queryParams(
        params
      )}`,
      { headers: this.header() }
    );
  },
  getPaymentAddress(data) {
    const params = {
      payMethod: data,
    };
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/fund/getPaymentAddress${this.queryParams(
        params
      )}`,
      { headers: this.header() }
    );
  },
  /* 获取支付方式汇率*/
  getPaymentRate(data) {
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/fund/getPaymentRate${this.queryParams(
        data
      )}`,
      { headers: this.header() }
    );
  },
  /* 获取最低存款金额*/
  getMinDepositAmount() {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/fund/getMinDepositAmount${this.queryParams()}`,
      { headers: this.header() }
    );
  },
  /* 存款数据验证（前置验证）*/
  depositDataValidate(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/fund/depositDataValidate`,
      this.requestBody(data),
      { headers: this.header() }
    );
  },
  /* 存款（提交保存）*/
  addDeposit(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/fund/addDeposit`,
      this.requestBody(data),
      {
        headers: this.header(),
      }
    );
  },
  /* 存款记录*/
  getDepositProposalList(data) {
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/fund/getDepositProposalList${this.queryParams(data)}`,
      { headers: this.header() }
    );
  },
  addTransfer(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/fund/addTransfer`,
      data,
      {
        headers: this.header(),
      }
    );
  },
  getTransferProposalList(data) {
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/fund/getTransferProposalList${this.queryParams(data)}`,
      { headers: this.header() }
    );
  },
  /* 汇率获取*/
  getRate(data) {
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/fund/getRate${this.queryParams(data)}`,
      {
        headers: this.header(),
      }
    );
  },
  /* 校验提现所需要的证明状态*/
  getWithdrawAuthCertify() {
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/risk/getWithdrawAuthCertify${this.queryParams()}`,
      { headers: this.header() }
    );
  },
  /* 可提现金额*/
  getAdvisableCredit(data) {
    const params = {
      gts2AccountId: data,
    };
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/withdraw/getAdvisableCredit${this.queryParams(params)}`,
      { headers: this.header() }
    );
  },
  /* 提现手续费列表*/
  getWithdrawFeeList(data) {
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/withdraw/getWithdrawFeeList${this.queryParams(data)}`,
      { headers: this.header() }
    );
  },
  /* 提现校验（前置验证）*/
  withdrawDataValidate(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/withdraw/withdrawDataValidate`,
      this.requestBody(data),
      { headers: this.header() }
    );
  },
  /* 提现（提交保存）*/
  addWithdraw(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/withdraw/addWithdraw`,
      this.requestBody(data),
      { headers: this.header() }
    );
  },
  /* 提现记录*/
  getWithdrawProposalList(data) {
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/withdraw/getWithdrawProposalList${this.queryParams(data)}`,
      { headers: this.header() }
    );
  },
  confirmWithdraw(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/withdraw/confirmWithdraw`,
      data,
      { headers: this.header() }
    );
  },
  /* 交易记录*/
  tradeRecord(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/tradereport/tradeRecord`,
      this.requestBody(data),
      { headers: this.header() }
    );
  },
  /* 委托记录*/
  entrustRecord(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/tradereport/entrustRecord`,
      this.requestBody(data),
      { headers: this.header() }
    );
  },
  /* 盈亏记录*/
  profitAndLossRecord(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/tradereport/profitAndLossRecord`,
      this.requestBody(data),
      { headers: this.header() }
    );
  },
  /* 额度记录*/
  creditRecord(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/tradereport/creditRecord`,
      this.requestBody(data),
      { headers: this.header() }
    );
  },
  /* 止盈止损记录*/
  stopLossRecordList(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/tradereport/tradeRecordForStopLoss`,
      this.requestBody(data),
      { headers: this.header() }
    );
  },
  /* 止盈止损记录详情*/
  stopLossRecord(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/tradereport/stopLossRecord`,
      this.requestBody(data),
      { headers: this.header() }
    );
  },
  /* 获取紧急平仓权限*/
  getEmergencyAuth() {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/emergency/getEmergencyAuth`,
      { headers: this.header() }
    );
  },
  /* 获取持仓数据*/
  getDealList(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/emergency/getDealList?` + data,
      { headers: this.header() }
    );
  },
  /* 平仓*/
  closePosition(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/emergency/closePosition`,
      data,
      { headers: this.header() }
    );
  },
  /* 撤单*/
  closeOrder(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/emergency/cannelOrder`,
      data,
      { headers: this.header() }
    );
  },
  /* 公告列表*/
  getNoticeList(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/notice/getNoticeList?` + data,
      { headers: this.header() }
    );
  },
  /* 公告详情*/
  getNoticeDetail(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/notice/getNoticeDetail/` + data,
      { headers: this.header() }
    );
  },
  /* 未完成事项*/
  getUnfinishProceeding(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/ordinary/getUnfinishProceeding?gts2CustomerId=` +
        data,
      { headers: this.header() }
    );
  },
  /* 修改邮箱*/
  updateEmail(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/person/updateEmail`,
      data,
      { headers: this.header() }
    );
  },
  /* 发送电邮地址验证邮件 */
  sendVerifyEmail(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/person/sendVerifyEmail`,
      data,
      { headers: this.header() }
    );
  },
  /* 账户升级*/
  accountUpgrade(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/account/accountUpgrade`,
      data,
      { headers: this.header() }
    );
  },
  /* 获取升级的下一个级别*/
  getAccountLevelByGts2AccountId(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/account/getAccountLevelByGts2AccountId?gts2AccountId=` +
        data,
      { headers: this.header() }
    );
  },
  /* 人脸识别*/
  faceVerity(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + `/risk/faceVerity`,
      data,
      {
        headers: this.header(),
      }
    );
  },
  /* 人脸失败后判断手持证件*/
  getFailFaceAuthority(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL +
        `/risk/getFailFaceAuthority?faceType=` +
        data,
      { headers: this.header() }
    );
  },
  /* 查询历史分笔产品列表*/
  getQuoteProduct() {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/quote/getQuoteProduct`,
      {
        headers: this.header(),
      }
    );
  },
  /* 历史分笔查询接口*/
  queryQuoteList(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/quote/queryQuoteList?` + data,
      { headers: this.header() }
    );
  },
  /* 判断产品是否持仓*/
  judgePosition(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/quote/judgePosition?` + data,
      { headers: this.header() }
    );
  },
  /* 获取服务器默认时间*/
  getDefaultTime() {
    return axiosReq.get(process.env.VUE_APP_API_URL + `/quote/getDefaultTime`, {
      headers: this.header(),
    });
  },
  /* 根据APP获取对应的渠道*/
  getFaceChannel(data) {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + `/risk/getFaceChannel?` + data,
      { headers: this.header() }
    );
  },
  getWithdrawMethod() {
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/withdraw/getWithdrawMethod${this.queryParams()}`,
      { headers: this.header() }
    );
  },
  getWalletList() {
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/bank/getWalletList${this.queryParams()}`,
      {
        headers: this.header(),
      }
    );
  },
  deleteWallet(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + '/bank/deleteWallet',
      data,
      { headers: this.header() }
    )
  },
  // 小金库一键注册
  // registerWallet(data, headers) {
  //     return axiosReq.post(process.env.VUE_APP_API_URL + '/bank/registerWallet', data, { headers: Object.assign(headers, this.header()) })
  // },
  getSupportWalletList() {
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/bank/getSupportWalletList`,
      {
        headers: this.header(),
      }
    );
  },
  addWallet(data, headers) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + "/bank/addWallet",
      data,
      {
        headers: Object.assign(headers, this.header()),
      }
    );
  },
  updateRemindRisk(data) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + "/person/updateRemindRisk",
      data,
      { headers: this.header() }
    );
  },
  // 獲取推薦鏈接
  getReferralLink(data) {
    return axiosReq.post(
      process.env.VUE_APP_MIS +
        "/public/cfd/customerRelation/getRelationUrlByPhone",
      data,
      { headers: this.header3() }
    );
  },
  /**
   * @param {('REAL_CURRENCY'|'VIRTUAL_CURRENCY')} data
   */
  getCanWithdraw(data) {
    const params = {
      paymentType: data,
    };
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/withdraw/canWithdraw${this.queryParams(
        params
      )}`,
      { headers: this.header() }
    );
  },
  getMinWithdraw() {
    return axiosReq.get(
      process.env.VUE_APP_API_URL + "/withdraw/getMinWithdraw",
      {
        headers: this.header(),
      }
    );
  },
  getMaxWithdraw() {
    return axiosReq.get(
      `${
        process.env.VUE_APP_API_URL
      }/withdraw/getMaxWithdraw${this.queryParams()}`,
      {
        headers: this.header(),
      }
    );
  },
  /**
   * @param {string} wechatId
   */
  updateWechatId(wechatId) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + "/person/updateWechatId",
      wechatId,
      {
        headers: this.header(),
      }
    );
  },
  /**
   * @param {string} telegramId
   */
  updateTelegramId(telegramId) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + "/person/updateTelegramId",
      telegramId,
      {
        headers: this.header(),
      }
    );
  },
  /**
   * @param {string} twitterId
   */
  updateTwitterId(twitterId) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + "/person/updateTwitterId",
      twitterId,
      {
        headers: this.header(),
      }
    );
  },
  /**
   * @param {string} dingTalkId
   */
  updateDingTalkId(dingTalkId) {
    return axiosReq.post(
      process.env.VUE_APP_API_URL + "/person/updateDingtalkId",
      dingTalkId,
      {
        headers: this.header(),
      }
    );
  },
  uploadAttachments(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/fund/uploadAttachments`,
      data,
      {
        headers: this.header(),
      }
    );
  },
  confirmDeposit(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_API_URL}/fund/confirmDeposit`,
      data,
      {
        headers: this.header(),
      }
    );
  },
  matchAmountSetting(data) {
    const params = {
      driverType: data,
    };
    return axiosReq.get(
      // `${
      //   process.env.VUE_APP_MIS
      // }/public/cfd/matchAmountSetting/list${this.queryParams(params)}`,
      `${
        process.env.VUE_APP_API_URL
      }/fund/getMatchAmountSetting${this.queryParams(params)}`,
      { headers: this.header() }
    );
  },
  hasManyDeposit() {
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/fund/hasManyDeposit${this.queryParams()}`,
      {
        headers: this.header(),
      }
    );
  },
  queryForAppH5(data) {
    return axiosReq.post(
      `${process.env.VUE_APP_MIS}/public/advertisingH5/queryForApp`,
      this.requestBody(data),
      { headers: this.header3() }
    )
  },
  getCurrentIp() {
    return axiosReq.get(
      'https://api.ipify.org?format=json'
    )
  },
  async getAllAppChannels() {
    return axiosReq.get(
      `${process.env.VUE_APP_NEW_MIS_API}/app-channel/channels`,
      { headers: this.header2() }
    )
  },
  async validateIdCard(data) {
    return await axiosReq.post(
      `${process.env.VUE_APP_API_URL}/person/validateIdCard`,
      data,
      {
        headers: this.header()
      }
    )
  },
  async whiteListValidate(data) {
    return await axiosReq.post(
      `${process.env.VUE_APP_MIS}/public/whiteList/validate`,
      data,
      {
        headers: this.headersForMis()
      }
    )
  },
  async isExistedEmail(data) {
    return await axiosReq.post(
      `${process.env.VUE_APP_MIS}/public/cfd/account/is-existed-email.json`,
      data,
      {
        headers: this.headersForMisJson()
      }
    )
  },
  async updatePersonalData(data) {
    return await axiosReq.post(
      `${process.env.VUE_APP_API_URL}/person/updatePersonalData`,
      data,
      {
        headers: this.header()
      }
    );
  },
  async getReminders(id) {
    const params = {
      name: id
    };
    return axiosReq.get(
      `${process.env.VUE_APP_API_URL}/fund/getReminders${this.queryParams(params)}`,
      {
        headers: this.header()
      }
    )
  }
}
